<template>
    <vue-phone-number-input ref="vuePhoneNumberInput" v-bind="$attrs" v-model="numberPhone.current" v-dusk="'phone'"
        :default-country-code="countryCode" :fetch-country="insideFetchCountry"
        @phone-number-focused="$emit('focus', $event)" @update="handlerUpdate" :translations="translations" />
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Vue from "vue";
import ApiService from "../api/api";

export default {
    name: "InputPhoneByCountry",
    components: { VuePhoneNumberInput },
    props: {
        value: {
            default: null,
            requested: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        fetchCountry: {
            type: Boolean,
            default: true
        }
    },
    directives: {
        dusk: {
            bind(el, binding) {
                const input = el.querySelector('.input-tel__input');

                input.setAttribute('dusk', binding.value);
            }
        }
    },
    data() {
        return {
            numberPhone: {
                current: this.value,
                original: null
            },
            countryCode: null,
            insideFetchCountry: false,
            translations: {
                countrySelectorLabel: Vue.prototype.$lang('InputPhoneByCountry.countrySelectorLabel'),
                countrySelectorError: Vue.prototype.$lang('InputPhoneByCountry.countrySelectorError'),
                phoneNumberLabel: this.placeholder,
                example: Vue.prototype.$lang('InputPhoneByCountry.example')
            },
        };
    },
    watch: {
        value(val) {
            if (this.numberPhone.original === null) {
                this.numberPhone.original = val;
            }

            if (this.numberPhone.current === val) {
                return;
            }

            this.numberPhone.current = val;
        },
        'numberPhone.original'(val) {
            if (val === null) {
                return;
            }

            const detectCountryCode = (country) => {
                let regExp = RegExp('^\\+?' + country.dialCode);

                if (regExp.test(val)) {
                    this.$set(this, 'countryCode', country.iso2);
                }
            };

            this.$refs.vuePhoneNumberInput.codesCountries.forEach(detectCountryCode);
        },
        fetchCountry() {
            this.detectCountry()
        }
    },
    methods: {
        handlerUpdate(event) {
            this.$emit('isValid', event.isValid);

            if (event.isValid && event.hasOwnProperty('formatInternational')) {
                this.$emit('input', event.formatInternational);
            } else if (!event.hasOwnProperty('nationalNumber')) {
                this.$emit('input', null);
            }
        },
        detectCountry() {
            if (!this.fetchCountry) {
                this.insideFetchCountry = false;

                return;
            }

            ApiService.infoCurrentIp().then(response => {
                this.countryCode = response.country;
            }).catch(error => {
                this.insideFetchCountry = true;
            })
        },
    },
    mounted() {
        this.detectCountry();

        this.fixPositionsInterval = setInterval(() => {
            const items = document.querySelectorAll(
                '.vue-recycle-scroller__item-view'
            );

            items.forEach((el, index) => {
                el.style.transform = `translateY(${index * 30}px)`;
            });

            const wrapper = document.querySelector(
                '.vue-recycle-scroller__item-wrapper'
            );

            if (wrapper) {
                wrapper.style.minHeight = `${items.length * 30}px`;
            }
        }, 100);
    },

    beforeDestroy() {
        clearInterval(this.fixPositionsInterval);
    }
}
</script>
